class LoginModal extends HTMLElement {
  constructor() {
    super();

    this.close = this.querySelector("[data-close]");

    this.handleOpen = (e) => {
      console.log("e", e);
      this.focusOnClose = e.target;
      this._open();
    };

    this.handleClose = (e) => {
      this._close();
    };

    this.handleDocumentClick = (e) => {
      if (this._isOpen && !this.contains(e.target)) {
        this._close();
      }
    };

    this.handleKeyUp = (e) => {
      if (this._isOpen && e.code.toUpperCase() === "ESCAPE") {
        this._close();
      }
    };

    this.close.addEventListener("click", () => this._close());
  }

  connectedCallback() {
    document.addEventListener("login-modal:open", this.handleOpen);
    document.addEventListener("login-modal:close", this.handleClose);
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  disconnectedCallback() {
    document.removeEventListener("login-modal:open", this.handleOpen);
    document.removeEventListener("login-modal:close", this.handleClose);
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  _open() {
    this.style.display = null;
    window.openFullDimmer(this);

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      this._isOpen = true;
      window.lockScroll(this);
      window.trapFocus(this);
    });
  }

  _close() {
    if (!this._isOpen) return;

    const handleTransitionEnd = () => {
      this.removeEventListener("transitionend", handleTransitionEnd);
      this.style.display = "none";
      window.removeTrapFocus(this.focusOnClose);
      window.unlockScroll(this);
      this._isOpen = false;
    };

    this.addEventListener("transitionend", handleTransitionEnd);
    this.removeAttribute("open");
    window.closeFullDimmer(this);
  }
}

if (!customElements.get("login-modal")) {
  customElements.define("login-modal", LoginModal);
}
